import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("tikra_token", data.token);
      localStorage.setItem("tikra_email", data.email);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="mb-10">
          <div className="stamp mb-6">Admin · Ingress</div>
          <h1 className="font-display text-5xl text-[#F2E7D0]">
            Tikratoli<br/><em className="italic text-[#D97645]">Console</em>
          </h1>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="space-y-5">
          <div>
            <Label className="font-mono-label text-[#B8A891]">Email</Label>
            <Input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 bg-transparent border-white/20 rounded-none h-12"
              autoFocus
            />
          </div>
          <div>
            <Label className="font-mono-label text-[#B8A891]">Password</Label>
            <Input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-transparent border-white/20 rounded-none h-12"
            />
          </div>
          <Button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full rounded-none bg-[#D97645] hover:bg-[#C0602F] text-[#F2E7D0] font-mono-label h-12"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </main>
  );
}
